var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyIconCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2333 14.3002H17.9333C18.3046 14.3002 18.6607 14.1527 18.9232 13.8901C19.1858 13.6276 19.3333 13.2715 19.3333 12.9002V6.6002C19.3333 6.22889 19.1858 5.8728 18.9232 5.61025C18.6607 5.34769 18.3046 5.2002 17.9333 5.2002H11.6333C11.2619 5.2002 10.9059 5.34769 10.6433 5.61025C10.3808 5.8728 10.2333 6.22889 10.2333 6.6002V7.3002M13.0333 10.1002H6.73325C5.96005 10.1002 5.33325 10.727 5.33325 11.5002V17.8002C5.33325 18.5734 5.96005 19.2002 6.73325 19.2002H13.0333C13.8065 19.2002 14.4333 18.5734 14.4333 17.8002V11.5002C14.4333 10.727 13.8065 10.1002 13.0333 10.1002Z",
    stroke: "#7F8DA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyIconCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy-icon-card.445f36f68731465ff4c086ccf471e4b9.svg";